module.exports = __webpack_public_path__ + "static/media/twitter.210c76e3.svg";